exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap .all-screen{position:fixed;left:0;top:0;width:100%;z-index:100\n}\n.wrap .content{position:absolute!important;left:50%;top:50%;-webkit-transform:translate(-50%,-55%);transform:translate(-50%,-55%)\n}\n.wrap .content .no-data{display:block;margin:auto;width:175px\n}\n.wrap .content p{font-size:16px;color:#666;text-align:center\n}\n.el-loading-parent--relative{position:static!important\n}", ""]);

// exports
